// @flow

import React from 'react';
import identityKey from 'identity-keys';
import type { MixedBlock as MixedBlockType } from 'message-parsing';

import MessageBlock from './MessageBlock';
import type { ServiceBubblePropType } from './ServiceBubblePropType';

type MixedBlockProps = {
  block: MixedBlockType,
  serviceBubbles: ServiceBubblePropType,
  handleLinkFormat: boolean,
};
export default function MixedBlock({ block, serviceBubbles, handleLinkFormat }: MixedBlockProps) {
  return Array.from(block.eachPart()).map(part => (
    <MessageBlock
      inline
      key={identityKey(part)}
      serviceBubbles={serviceBubbles}
      handleLinkFormat={handleLinkFormat}
      block={part}
    />
  ));
}
